import * as types from "./actionTypes"

const initialState = {
    requests: [],
    firstRequest: {},
    requestDetails: {
        modifiedDate: "",
        quantity: 0,
        status: "",
        serviceDateTime: "",
        requestId: "",
    },
    equipmentDetails: [],
    detailOptions: {},
    newRequestCreated: false,
}
export default function generalPlacementReducer(state = initialState, action) {
    switch (action.type) {
        case types.FETCH_ALL_REQUESTS_SUCCESS:
            return {
                ...state,
                requests: action.payload
                    ? action.payload.sort((a, b) => {
                          return (
                              new Date(b.serviceDateTime) -
                              new Date(a.serviceDateTime)
                          )
                      })
                    : [],
                firstRequest: action.payload
                    ? action.payload.sort((a, b) => {
                          return (
                              new Date(b.serviceDateTime) -
                              new Date(a.serviceDateTime)
                          )
                      })[0]
                    : {},
            }
        case types.FETCH_REQUEST_DETAILS_SUCCESS:
            return {
                ...state,
                requests: action.payload.requestsData
                    ? action.payload.requestsData.sort((a, b) => {
                          return (
                              new Date(b.serviceDateTime) -
                              new Date(a.serviceDateTime)
                          )
                      })
                    : [],
                firstRequest: action.payload.requestsData
                    ? action.payload.requestsData.sort((a, b) => {
                          return (
                              new Date(b.serviceDateTime) -
                              new Date(a.serviceDateTime)
                          )
                      })[0]
                    : {},

                requestDetails: {
                    createdDate: action.payload.requestDetails.createdDate,
                    createdBy: action.payload.requestDetails.createdBy,
                    totalQuantity: action.payload.requestDetails.totalQuantity,
                    status: action.payload.requestDetails.status,
                    serviceDateTime:
                        action.payload.requestDetails.serviceDateTime,
                    requestId: action.payload.requestDetails.requestId,
                },
                equipmentDetails:
                    action.payload.requestDetails["equipmentDetails"],
            }
        case types.FETCH_REQUEST_ALL_DETAILS:
            return {
                ...state,
                requestDetails: {
                    createdDate: action.payload.createdDate,
                    createdBy: action.payload.createdBy,
                    totalQuantity: action.payload.totalQuantity,
                    status: action.payload.status,
                    serviceDateTime: action.payload.serviceDateTime,
                    requestId: action.payload.requestId,
                },
                equipmentDetails: action.payload["equipmentDetails"],
            }
        case types.FETCH_DETAILS_VALUE_OPTIONS_SUCCESS: {
            const optionValues = action.payload.ShipmentsFilterFieldsValues
            const filters = {}

            optionValues.forEach((filter) => {
                if (filters[filter.Type])
                    filters[filter.Type].push(filter.Value)
                else filters[filter.Type] = [filter.Value]
            })
            return {
                ...state,
                detailOptions: filters,
            }
        }

        case types.CREATE_NEW_REQUESTS_SUCCESS:
            return {
                ...state,
                newRequestCreated: true,
            }
        case types.CREATE_NEW_REQUESTS_RESET:
            return {
                ...state,
                newRequestCreated: false,
            }
        case types.CLEAR_STATE_DATA:
            return {
                ...initialState,
            }
        default:
            return state
    }
}
